import BaseAreaPulldown from "./BaseAreaPulldown";
import BasePathPulldown from "./BasePathPulldown";
import BaseFieldPulldown from "./BaseFieldPulldown";

const optionElements = (options) => {
  return options.map((option, index) => {
    return (<option value={option.id} key={index}>
      {option.name}
    </option>)
  })
}

const selectClassNames = `
  form-select
  block
  w-full
  px-1 md:px-4 xl:px-7
  py-1 md:py-2 xl:py-3
  text-xs sm:text-sm md:text-base
  font-normal
  bg-white bg-clip-padding bg-no-repeat
  border-2 border-solid border-yellow
  rounded-b-sm
  transition
  ease-in-out
  m-0
  focus:bg-white focus:outline-none
  cursor-pointer
`

function BaseSelectionPulldown({ selectElementData, selectedState, onSelect = f => f }) {
  return (
    <div className="block">
      {
        (() => {
          const baseCondition = selectElementData.selectionTarget
          switch (baseCondition) {
            case "area":
              return (
                <BaseAreaPulldown selectClassNames={selectClassNames} selectedState={selectedState} onSelect={onSelect}>
                  { optionElements(selectElementData.options) }
                </BaseAreaPulldown>
              )
            case "path":
              return (
                <BasePathPulldown selectClassNames={selectClassNames} selectedState={selectedState} onSelect={onSelect}>
                  { optionElements(selectElementData.options) }
                </BasePathPulldown>
              )
            case "field":
              return (
                <BaseFieldPulldown selectClassNames={selectClassNames} selectedState={selectedState} onSelect={onSelect}>
                  { optionElements(selectElementData.options) }
                </BaseFieldPulldown>
              )
            default:
              return (
                <BaseFieldPulldown selectClassNames={selectClassNames} selectedState={selectedState} onSelect={onSelect}>
                  { optionElements(selectElementData.options) }
                </BaseFieldPulldown>
              )
          }
        })()
      }
    </div>
  );
}

export default BaseSelectionPulldown;
